const $ = window.jQuery;

module.exports = {

    init: function () {
    // Scroll to Top button
    var scrollButton = document.getElementById('scroll-to-top');

    // When the user scrolls down 20px from the top of the document, show the button
    window.onscroll = function() {scrollFunction()};

    function scrollFunction() {
      if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
        // scrollButton.style.display = 'block';
        scrollButton.classList.add('show-btn');
      } else {
        // scrollButton.style.display = 'none';
        scrollButton.classList.remove('show-btn');
      }
    }
    },

};